import React, { useEffect, useState } from 'react';
import { API } from 'aws-amplify';
import ProductCard from '../components/ProductCard';
import ProductDetailsModal from '../components/ProductDetailsModal';
import { useCart } from '../components/CartContext'; // Ensure correct import path
import mockProducts from '../mockProducts.json'; // Import the mock data

function Home() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await API.get('apiNtrepid', '/items', {
          queryStringParameters: {
            type: 'Feature' // Home Page type
          }
        });

        const featuredProducts = (response.items || response).filter(item => item.type === 'Feature');

        // Sort the products based on the predefined custom size order
        const sizeOrder = [
          'x1Custom',
          'x2Custom',
          'x3Custom',
          'x4Custom',
          'x5Custom',
          'x6Custom',
          'x7Custom',
          'x8Custom',
          'x9Custom',
          'x10Custom'
        ];

        const firstTenOrdered = featuredProducts
          .filter(product => sizeOrder.includes(product.size))
          .sort((a, b) => sizeOrder.indexOf(a.size) - sizeOrder.indexOf(b.size));

        const remainingRandom = featuredProducts
          .filter(product => !sizeOrder.includes(product.size))
          .sort(() => Math.random() - 0.5);

        setProducts([...firstTenOrdered, ...remainingRandom]);
      } catch (error) {
        console.error('Error fetching products:', error);

        // Handle mock data when sizeOrder isn't applicable
        const mockFeaturedProducts = mockProducts.filter(item => item.type === 'Feature');

        // Take the first ten products as-is from the mock data
        const firstTenMock = mockFeaturedProducts.slice(0, 10);

        // Randomize the remaining mock products
        const remainingRandomMock = mockFeaturedProducts
          .slice(10)
          .sort(() => Math.random() - 0.5);

        setProducts([...firstTenMock, ...remainingRandomMock]);
      }
    };
    fetchProducts();
  }, []);

  const handleViewDetails = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  return (
    <div className="container px-4 px-lg-5 mt-5">
      <div className="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
        {products.map(product => (
          <ProductCard key={product.id} product={product} onViewDetails={handleViewDetails} />
        ))}
      </div>
      <ProductDetailsModal
        show={showModal}
        handleClose={handleCloseModal}
        product={selectedProduct}
        addToCart={addToCart}
      />
    </div>
  );
}

export default Home;